import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles, Paper, Typography, IconButton, Divider, Drawer, Avatar, Button} from '@material-ui/core'
import classNames from 'classnames'
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import Add from '@material-ui/icons/Add'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import MaterialUiIconPicker from 'react-material-ui-icon-picker'

import {SubmitButton, ArrowToolTip, FormElement, PageContainer, MaterialIcon} from '../../../components/components'
import TabContainer from '../TabContainer'

import {clearFormFields} from '../../../util/misc'
const styles = {
    featuresFormContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '1em',
        border: '1px solid #e0e0e0',
        marginBottom: '3em'
    },

    featuresFormTitle: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '1.5em',
        fontWeight: 300,
        paddingLeft: '0.5em'
    },

    formTitle: {
        paddingLeft: '0em'
    },

    featureIconPickerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: '0.5em'
    },

    selectedFeatureIconLabel: {
    },

    selectedFeatureIcon: {
        color: '#fff',
        marginLeft: '1em',
        marginRight: '1em'
    },

    addNoteSubmitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '2em',
        marginBottom: '1em',
        alignSelf: 'center'
    },

    featureItem: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: '0.5em',
        paddingLeft: '0.5em',
        paddingBottom: '0.5em',
        borderBottom: '1px solid #e0e0e0'
    },

    featureIcon: {
        marginRight: '0.5em'
    },


    submitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '5em',
        alignSelf: 'center'
    },

    pageContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        transitionDuration: '1s',
        paddingTop: '1em',
        paddingBottom: '2em'
    },

    pageInnerContainer: {
        paddingTop: '1em'
    },

    createNewNote: {
        marginTop: '0.5em',
        paddingLeft: '0.5em',
        alignSelf: 'flex-start'
    },

    note: {
        flex: 1
    }
}

const Direction = {
    Up: 'up',
    Down: 'down'
}

class FeaturesEdit extends Component {
    state = {
        isDisabled: true,
        isOpen: false,
        editingNote: null,
        selectedFeatureIcon: null,
        isProcessing: false
    }

    onValidationChangeDetected = () => {
        console.log(this.formInputFields)
        this.setState({isDisabled: (!this.formInputFields.note.state.isValid || this.state.selectedFeatureIcon === null)})
    }

    toggleForm = isOpen => () => {
        this.setState({isOpen})
        clearFormFields(this.formInputFields)
    }

    onAddClick = () => {
        this.setState({isOpen: true, editingNote: null, selectedFeatureIcon: null})
    }

    onEditClick = editingNote => () => {
        this.setState({editingNote, isOpen: true, selectedFeatureIcon: editingNote.icon})
        this.formInputFields.note.setValue(editingNote.description)
    }

    onMove = (editingNote, dir) => () => {
        const formData = new FormData()
        formData.append('feature[id]', editingNote.id)
        formData.append(`feature[${dir}]`, 1)

        this.props.editProjectDetails(this.props.projectDetails.id, formData, this.toggleForm(false))
    }

    onDeleteClick = featureId => () => {
        const formData = new FormData()
        formData.append('feature[id]', featureId)
        formData.append('feature[delete]', 1)

        this.props.editProjectDetails(this.props.projectDetails.id, formData, this.toggleForm(false))
    }

    onSubmitOrUpdate = () => {
        const formData = new FormData()
        if (this.state.editingNote) formData.append('feature[id]', this.state.editingNote.id)
        formData.append('feature[note]', this.formInputFields.note.state.value)
        formData.append('feature[icon]', this.state.selectedFeatureIcon)

        this.props.editProjectDetails(this.props.projectDetails.id, formData, this.toggleForm(false))
    }

    showPickedIcon = icon => {
        this.setState({selectedFeatureIcon: icon.name, isDisabled: !this.formInputFields.note.state.isValid})
    }

    noteField = {label: 'Note', name: 'note', minLength: 5, maxLength: 250, type: 'text', required: true}

    formInputFields = {}
    picker = {}

    render () {
        const {classes: styles, active, projectDetails} = this.props
        const {isOpen, editingNote, isDisabled} = this.state
        const projectName = projectDetails ? projectDetails.name : ''

        return (
            <TabContainer active={active} title={'Update  Notes'}>
                <Paper className={styles.featuresFormContainer} elevation={0}>
                    <Typography variant="h5" color="inherit" className={styles.featuresFormTitle}>
                        Manage Notes
                        <ArrowToolTip title={'Add Note'}>
                            <IconButton color={'primary'} onClick={this.onAddClick}>
                                <Add />
                            </IconButton>
                        </ArrowToolTip>
                    </Typography>
                    <Divider />

                    {projectDetails && projectDetails.features.map((info, index) => (
                        <div key={index} className={styles.featureItem}>
                            <Avatar className={styles.featureIcon}><MaterialIcon icon={info.icon} /></Avatar>
                            <Typography variant="body2" color="inherit" className={styles.note}>
                                {info.description}
                            </Typography>

                            <ArrowToolTip title={'Move Up'}>
                                <IconButton color={'inherit'} onClick={this.onMove(info, Direction.Up)}>
                                    <KeyboardArrowUp />
                                </IconButton>
                            </ArrowToolTip>

                            <ArrowToolTip title={'Move Down'}>
                                <IconButton color={'inherit'} onClick={this.onMove(info, Direction.Down)}>
                                    <KeyboardArrowDown />
                                </IconButton>
                            </ArrowToolTip>

                            <ArrowToolTip title={'Edit'}>
                                <IconButton color={'primary'} onClick={this.onEditClick(info)}>
                                    <Edit />
                                </IconButton>
                            </ArrowToolTip>
                            <ArrowToolTip title={'Delete'} placement={'right'}>
                                <IconButton color={'secondary'} onClick={this.onDeleteClick(info.id)}>
                                    <Delete />
                                </IconButton>
                            </ArrowToolTip>
                        </div>
                    ))}
                    <Button className={styles.createNewNote} size={'small'} color={'primary'} onClick={this.onAddClick}>
                        Create New Note
                    </Button>
                </Paper>
                <Drawer
                    anchor="bottom"
                    open={isOpen}
                    onClose={this.toggleForm(false)}
                    onOpen={this.toggleForm(true)}
                    disableEnforceFocus
                    keepMounted
                >

                    <PageContainer className={styles.pageContainer} containerClassName={styles.pageInnerContainer}>
                        <Typography variant={'h6'} color={'primary'} className={classNames(styles.featuresFormTitle, styles.formTitle)}>
                            {editingNote ? 'Update Note for' : 'Add New Note for'} {projectName}
                        </Typography>

                        <FormElement {...this.noteField} innerRef={ref => (this.formInputFields[this.noteField.name] = ref || this.formInputFields[this.noteField.name])} onValidationChangeDetected={this.onValidationChangeDetected} />

                        <MaterialUiIconPicker ref={ref => (this.picker = ref)} label={'Select an Icon'} modalTitle={'Note Icon'} onPick={this.showPickedIcon} />

                        <div className={styles.featureIconPickerContainer}>
                            <Typography variant={'body1'} className={styles.selectedFeatureIconLabel}>
                                    Selected Note Icon:
                            </Typography>
                            {this.state.selectedFeatureIcon
                                ? <Avatar className={styles.selectedFeatureIcon}><MaterialIcon icon={this.state.selectedFeatureIcon} /></Avatar>
                                : <Avatar className={styles.selectedFeatureIcon} />
                            }
                        </div>
                        <SubmitButton className={styles.addNoteSubmitButton} isDisabled={isDisabled} onClick={this.onSubmitOrUpdate} loadingText={'Updating..'}>{editingNote ? 'Update' : 'Submit'}</SubmitButton>
                    </PageContainer>

                </Drawer>
            </TabContainer>
        )
    }
}

FeaturesEdit.propTypes = {
    classes: PropTypes.object,
    active: PropTypes.bool,
    projectDetails: PropTypes.object
}

export default withStyles(styles)(FeaturesEdit);
